import React from 'react';
import { Link } from 'react-router-dom';
import { WritingLessonData } from '../../types';

type Props = {
    lesson: WritingLessonData,
}

export default ({ lesson }: Props) => {
    const { linkedAudioLesson } = lesson;

    return (
        <div>
            <h2>{lesson.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: lesson.text }} />
            {linkedAudioLesson && (
                <p>
                    Wenn du diese Übung verstärken möchtest, findest du
                    <Link to={linkedAudioLesson.link}>&raquo;hier&laquo;</Link>
                    {`die Audioübung ${linkedAudioLesson.title}.`}
                </p>
            )}
        </div>
    );
};
